import Vue from "vue";
import { newLogger } from "@/utils/util";
import network from "../../../utils/network";

let logger = newLogger("AdministrationDocumentPromptStore");

const urls = {
  documentWithId: (id) => `/administration/document-prompt/${id}`,
};

/**
 * Administration Document Prompt store
 */

const initState = () => {
  return {
    documentList: [],
    documentData: {},
  };
};

const actions = {
  fetchOne: async ({ commit }, id) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.documentWithId(id));
      commit("saveOne", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveOne: (state, data) => {
    Vue.set(state.documentData, data.id, data);
  },
};

const getters = {
  get: (state) => (id) => {
    return state.documentData[id];
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
